import { render, staticRenderFns } from "./directorBulletinComponent.vue?vue&type=template&id=4bcad2f8&scoped=true"
import script from "./directorBulletinComponent.vue?vue&type=script&lang=js"
export * from "./directorBulletinComponent.vue?vue&type=script&lang=js"
import style0 from "./directorBulletinComponent.vue?vue&type=style&index=0&id=4bcad2f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcad2f8",
  null
  
)

export default component.exports